/**
 * Spanish translations
 */
import { common } from './es/common';
import { dashboard } from './es/dashboard';
import { vision2040 } from './es/vision2040';
import { mentalHealth } from './es/mentalHealth';
import { members } from './es/members';
import { programs } from './es/programs';
import { technology } from './es/technology';
import { regional } from './es/regional';
import { impact } from './es/impact';
import { workforce } from './es/workforce';
import { entrepreneurship } from './es/entrepreneurship';
import { contributing } from './es/contributing';
import { faq } from './es/faq';
import { methodology } from './es/methodology';
import { developmentCouncils } from './es/developmentCouncils';
import { privacy } from './es/privacy';
import { terms } from './es/terms';
import { countryProfile } from './es/countryProfile';

// NOTE: both Programs & Events and Technology modules used the same root key "programs".
// We deep-merge here to prevent one module from overwriting the other.
const { programs: programsLabels, ...programsRest } = programs;
const { programs: technologyProgramLabels, ...technologyRest } = technology;

export const es = {
  ...common,
  ...dashboard,
  ...mentalHealth,
  ...regional,
  ...members,
  ...programsRest,
  ...impact,
  ...technologyRest,
  ...vision2040,
  ...workforce,
  ...entrepreneurship,
  ...contributing,
  ...methodology,
  ...developmentCouncils,
  ...countryProfile,
  privacy,
  terms,
  faq,
  programs: {
    ...programsLabels,
    ...technologyProgramLabels,
  },
} as const;

export type EsTranslations = typeof es;

